import styled from 'styled-components';
import { shade } from 'polished';

export const TitleSearch = styled.span`
  padding-left: 30%;
  color: #006699;
  font-weight: bold;
  font-family: sans-serif;
  white-space: pre-wrap;
`;

export const ValuesSelected = styled.span`
  padding-left: 10px;
  font-family: sans-serif;
  white-space: pre-wrap;
  text-align: left;
`;

export const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const ContainerSearch = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ButtonSearch = styled.button`
  width: 32px;
  height: 32px;
  border: 0px;
  border-radius: 4px;
  background: transparent;

  &:hover {
    background: ${shade(0.2, '#fff')};
  }

  svg {
    width: 100%;
    height: 100%;
    color: #006699;
  }
`;
